/**
 * Monero hard fork info.
 */
export default class MoneroHardForkInfo {
    constructor(info) {
        Object.assign(this, info);
        if (this.credits !== undefined && typeof this.credits !== "bigint")
            this.credits = BigInt(this.credits);
    }
    toJson() {
        let json = Object.assign({}, this);
        if (json.credits !== undefined)
            json.credits = json.credits.toString();
        return json;
    }
    getEarliestHeight() {
        return this.earliestHeight;
    }
    setEarliestHeight(earliestHeight) {
        this.earliestHeight = earliestHeight;
        return this;
    }
    getIsEnabled() {
        return this.isEnabled;
    }
    setIsEnabled(isEnabled) {
        this.isEnabled = isEnabled;
        return this;
    }
    getState() {
        return this.state;
    }
    setState(state) {
        this.state = state;
        return this;
    }
    getThreshold() {
        return this.threshold;
    }
    setThreshold(threshold) {
        this.threshold = threshold;
        return this;
    }
    getVersion() {
        return this.version;
    }
    setVersion(version) {
        this.version = version;
        return this;
    }
    getNumVotes() {
        return this.numVotes;
    }
    setNumVotes(numVotes) {
        this.numVotes = numVotes;
        return this;
    }
    getWindow() {
        return this.window;
    }
    setWindow(window) {
        this.window = window;
        return this;
    }
    getVoting() {
        return this.voting;
    }
    setVoting(voting) {
        this.voting = voting;
        return this;
    }
    getCredits() {
        return this.credits;
    }
    setCredits(credits) {
        this.credits = credits;
        return this;
    }
    getTopBlockHash() {
        return this.topBlockHash;
    }
    setTopBlockHash(topBlockHash) {
        this.topBlockHash = topBlockHash;
        return this;
    }
}
